<template>
  <div  :style='{width: panelWidth}' >
      <el-table ref='bookdcptable' :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
          :cell-class-name = "() => 'lu-click'"
          :row-class-name="tableRowClassName"
          @row-dblclick='(row, column) => getDetail(row.instrumentName, row, column)'
          @sort-change='sortChange'
       >
        <el-table-column prop='instrumentName' ref='sortCol1' sortable='custom' :sortKeys="['instrumentName']" sortFieldFormat="String" />
        <el-table-column align='center' :label="getCurrentBookLabel">
          <el-table-column align='center' v-for='broker in bookBrokerList' :key='broker' :label='broker' ref='sortCol2' sortable='custom' :sortKeys="['book',broker,'value']" sortFieldFormat="Number">
            <template slot-scope="data">
              <div style='text-align: right' :class='cellClass(data.row.book[broker].value)'>{{ data.row.book[broker].value | formatAmount(bookPnLMode) }}</div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
// import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import elDragDialog from '@/directive/el-dragDialog'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import monitoringMixin from './mixins'
import { mapState } from 'vuex'

export default {
  name: 'BookDiscrepancies',
  directives: { elDragDialog },
  props: [ 'data', 'panel' ],
  mixins: [ monitoringMixin ],
  // components: { LuVbox, LuHbox, LuItem },
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    }
  },
  data: function () {
    return {
      bookBrokerList: [],
      tableData: [],
      currentFilter: {},
      bookPnLMode: 1,
      bookData: {}
    }
  },
  watch: {
    data: {
      handler (value) {
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({ panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    excelColumns () {
      let columns = []
      for (let i = 0; i < 26; i++) {
        columns.push(String.fromCharCode(0x41 + i))
      }
      for (let i = 0; i < 26; i++) {
        for (let j = 0; j < 26; j++) {
          columns.push(String.fromCharCode(0x41 + i) + String.fromCharCode(0x41 + j))
        }
      }
      return columns
    },
    // bookPnLMode: function () {
    //   let tmp = this.panelConfig.find(item => item.id === this.panel.id)
    //   return tmp ? tmp.options.bookPnLMode : 0
    // },
    getCurrentBookLabel() {
      return this.getBookLabel()
    },
    getCurrentDataField() {
      return this.getDataField(this.bookPnLMode)
    },
    getCurrentMode: function() {
      return this.getMode(this.bookPnLMode)
    },
    getLotsMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return !!tmp.options.lotsMios && tmp.options.lotsMios === 'lots' ? 'lots' : 'mios'
    }
  },
  methods: {
    sortChange: function(data) {
      const { column, order } = data

      let currentCol = this.getSortColumns().find(item => item.columnId === column.id)

      let sortKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        sortKeys = currentCol.$attrs.sortKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { sortKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getSortColumns: function() {
      let columns = []
      for (let ref of ["sortCol1", "sortCol2"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { sortKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(sortKeys) && Boolean(order))) {
        // default
        sortKeys = ['index']
        sortFieldFormat = 'Number'
        order = 'ascending'
        this.currentFilter = { sortKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(sortKeys,sortFieldFormat,order))
    },
    sortBy: function(sortKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,sortKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of sortKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,sortKeys,sortFieldFormat)
        let valueB = getPropValue(b,sortKeys,sortFieldFormat)

        // ref
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.bookBrokerList = data.bookBrokerList
      this.tableData = data.tableData
      this.bookData = data.bookData
      this.dataSort()
      this.updateLayout()
    },
    updateLayout() {
      if (this.$refs.bookdcptable && this.$refs.bookdcptable.doLayout) {
          this.$refs.bookdcptable.doLayout()
      }
    },
    getBookLabel() {
      // if (bookPnLMode) {
      //   return this.$t('STP Position')
      // } else {
      //   return this.$t('STP PnL')
      // }
      return this.$t('Book Discrepancies')
    },
    getDataField(bookPnLMode) {
      if (bookPnLMode) {
        if (this.getLotsMios === 'lots') {
          return 'numberOfLot'
        } else {
          return 'exposure'
        }
      } else {
        return 'profitAndLoss' 
      }
    },
    getMode(bookPnLMode) {
      return bookPnLMode ? 'E' : 'P'
    },
    getExcelSheetName() {
      // if (bookPnLMode) {
      //   return this.$t('STP Exposure')
      // } else {
      //   return this.$t('STP PnL')
      // }
      return this.$t('Book Discrepancies')
    },
    parseData (value, bookPnLMode = this.bookPnLMode) {
      let bookBrokerList = []
      let tableData = []
      let bookData = {}
      let index = 0

      if (value && value.length) {
        if (value[0] && value[0].bookList && value[0].bookList.length) {
          value[0].bookList.forEach(book => {
            bookBrokerList.push(book.bookName)
            bookData[book.bookName] = book
          })
        }

        if (value[0] && value[0].instrumentList && value[0].instrumentList.length) {
          value[0].instrumentList.forEach(item => {
            let row = {
              instrumentName: item.instrumentName,
              label: item.label,
              book: {}
            }

            if (item.bookList && item.bookList.length) {
              item.bookList.forEach((book,index) => {
                if (bookBrokerList[index]) {
                  if (book.hasOwnProperty(this.getDataField(bookPnLMode))) {
                    row.book[bookBrokerList[index]] = { value: book[this.getDataField(bookPnLMode)] }
                  } else {
                    row.book[bookBrokerList[index]] = { value: "0.00" }
                  }
                }
              })
            }
            index++
            row.index = index
            tableData.push(row)
          })
        }
      }
      return {
        bookBrokerList: bookBrokerList,
        tableData: tableData,
        bookData: bookData
      }
    },
    onChangeBookPnLMode () {
      this.updateData(this.data)
    },
    onChangeLotsMios () {
      this.updateData(this.data)
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []
        const columns = this.excelColumns

        let data = this.parseData(dataList)

        // let headers = [
        //   [ this.$t('Instrument') ],
        //   [ this.$t('Instrument') ],
        //   [ this.$t('Instrument') ],
        // ]
        let headers = [
          [ '' ],
          [ '' ],
          [ '' ],
        ]

        let merges = [ 'A1:A3' ]

        let col = 1

        // let start = col

        // Book
        merges.push(columns[col] + '1:' + columns[col + data.bookBrokerList.length - 1] + '1')
        data.bookBrokerList.forEach(s => {
          headers[0].push(this.getCurrentBookLabel)
          headers[1].push(s)
          headers[2].push(s)
          merges.push(columns[col] + '2:' + columns[col] + '3')
          col++
        })

        let tableData = []
        data.tableData.forEach(row => {
          let thisRow = []
          thisRow.push(row.instrumentName)

          data.bookBrokerList.forEach(s => {
            thisRow.push(row.book[s].value)
          })

          tableData.push(thisRow)
        })

        sheetList.push({
          multiHeader: headers,
          data: tableData,
          merges: merges,
          sheetName: this.getExcelSheetName()
        })

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    },
    getDetail: function (label,row,column) {
      let bookName = ""
      let platform = ""
      if (this.bookData && this.bookData[column.label]) {
        bookName = column.label
        platform = this.bookData[column.label].brokerName
      }

      // let params = [
      //   {'paramName': 'origin', 'paramValue': this.panel.id},
      //   {'paramName': 'symbol', 'paramValue': label},
      //   {'paramName': 'mode', 'paramValue': this.getCurrentMode}
      // ]
      // this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true})

      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'symbol', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true, platform: platform, bookName: bookName, lotsMios: 'lots'})
    }
  }
}
</script>

<style>
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>